import React from 'react';
import { Link } from 'react-router-dom';
import { ASSETS } from '../utils/assets';
import { trackEvent } from '../utils/analytics';

interface FooterProps {
  onContactClick?: () => void;
}

const Footer: React.FC<FooterProps> = ({ onContactClick }) => {
  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onContactClick?.();
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <img 
        src={ASSETS.footerBgLogo} 
        alt="" 
        className="footer-bg-logo" 
        aria-hidden="true"
      />
      <div className="footer-section">
        <div className="footer-column">
          <img
            src={ASSETS.logo}
            alt="StimmDigital Logo"
            className="footer-logo"
          />
          <ul>
            <li><Link to="/">Startseite</Link></li>
            <li>
              <a 
                href="#" 
                onClick={handleContactClick}
                data-action="contact"
              >
                Kontakt
              </a>
            </li>
            <li>
              <Link 
                to="/beratungstermin"
                onClick={() => trackEvent('Footer_Beratungstermin_Click')}
              >
                Termin vereinbaren
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Dienstleistungen</h4>
          <ul>
            <li><Link to="/mobile-app">Mobile App-Entwicklung</Link></li>
            <li><Link to="/website">Webentwicklung</Link></li>
            <li><Link to="/desktop-app">Desktop-Software</Link></li>
            <li><Link to="/website">UI/UX Design</Link></li>
            <li><Link to="/beratungstermin">IT-Beratung</Link></li>
            <li><Link to="/server-software">Server & Backend</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Ressourcen</h4>
          <ul>
            <li><Link to="/affiliate">Partner-Programm</Link></li>
            <li><a href="/sitemap.xml">Sitemap</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Rechtliches</h4>
          <ul>
            <li><Link to="/impressum">Impressum</Link></li>
            <li><Link to="/datenschutz">Datenschutzerklärung</Link></li>
            <li><Link to="/agb">Allgemeine Geschäftsbedingungen</Link></li>
          </ul>
          <p className="footer-description">
            StimmDigital - Software aus Berlin. Direkt, persönlich und ohne Umwege. Wir entwickeln digitale Produkte, die funktionieren.
          </p>
        </div>
      </div>

      <div className="footer-meta">
        <div className="footer-meta-content">
          <span>
            © Stimm Digital GmbH & Co. KG {currentYear} - Softwareentwicklung aus Berlin
          </span>
          <div className="made-with-love">
            Made with 
            <svg className="heart-icon" viewBox="0 0 24 24" fill="white">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
            </svg>
            in Berlin
          </div>
        </div>
        <nav>
          <a
            href="https://www.instagram.com/stimm.digital"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('Footer_Social_Click', { platform: 'Instagram' })}
          >
            <img src={ASSETS.instagram} alt="Instagram" />
          </a>
          <a 
            href="https://t.me/stimmdev" 
            aria-label="Telegram"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('Footer_Social_Click', { platform: 'Telegram' })}
          >
            <img src={ASSETS.telegram} alt="Telegram" />
          </a>
          <a 
            href="https://www.facebook.com/stimm.digital" 
            aria-label="Facebook"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('Footer_Social_Click', { platform: 'Facebook' })}
          >
            <img src={ASSETS.facebook} alt="Facebook" />
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
